import {
  ILabelModel,
  IMessageRecipient,
  IMessageUserModel,
  MessageState,
} from 'Modules/Communication/shared/models/Inbox'

export interface IEmailListItem {
  id: string
  title: string
  fromEmail: string
  fromName: string
  createdDate: Date
  sentDate: Date
  hasLabels: boolean
  hasAttachments: boolean
  hasExternalData: boolean
  isRepliedOn: boolean
  isForwarded: boolean
  isRead: boolean
  content: string
  recipients: IMessageRecipient[] | null
  email: IEmailModel
  caseId: string
  state: MessageState
  sendingFailure: boolean
  processedDate?: Date
  deletedDate?: Date
  labels: ILabelModel[]
}

export enum EmailTypeEnum {
  Sent = 'Sent',
  Draft = 'Draft',
  Received = 'Received',
}

export interface IEmailAttachment {
  attachmentId: string
  contentType: string
  filename: string
  downloadUrl: string
}

export interface IEmailExternalData {
  eventEnd: string
  eventStart: string
  eventLocation: string
}
export interface IEmailModel {
  id: string
  attachments: IEmailAttachment[]
  clientId: string
  content: string
  contentHtml: string
  contentUrl: string
  dateCreated: Date
  hasAttachments: boolean
  isForwarded: boolean
  title: string
  from: IMessageUserModel
  externalData: IEmailExternalData
  status: EmailTypeEnum
  type: 'Mail' | 'Sms'

  // Optionals
  sentDate?: Date
  receivedDate?: Date

  createdDate?: Date
  sendingStatusText?: string
  replyToMessageId?: string
  recipients?: IMessageRecipient[]
  labels?: ILabelModel[]
  readDate?: Date
  caseId?: string
  caseTitle?: string
  connectedMessageId?: string
  connectedMessageRecipients?: string[]

  deletedDate?: Date
  deletedBy?: IMessageUserModel
  processedDate?: Date
  processedBy?: IMessageUserModel
  parentRelation?: IEmailRelation
  forwardsOrReplies?: IEmailRelation[]
  state: MessageState

  // Only set for for Gmail SMTP. Used in order to move inbox messages
  queryId: string
}

export interface IEmailRelation {
  messageId: string
  relation: ParentRelationEnum | null
  when: Date
  name: string
  nameId: string
  state: MessageState
}

export interface ISendingStatusPayload {
  ClientId: string
  MessageId: string
  Success: boolean
  NotificationMessage: string
  Relation?: {
    MessageId: string
    Relation: ParentRelationEnum | null
    When: Date
    Name: string
    NameId: string
    State: MessageState
  }
}

export interface IEmailStatistics {
  unreadCount: number
  sendingFailureCount: number
}

export interface IEmailSeenByUser {
  nameId: string
  userFullName: string
}

export interface IEmailSeenBy {
  usersRead: IEmailSeenByUser[]
}

export interface IEmailSeenByUserSummary {
  messageId: string | null
  readCount: number
}

export enum JunkDestinationEnum {
  Inbox = 'Inbox',
  Deleted = 'Deleted',
}

export interface IMoveJunkModel {
  messageIds: string[]
  destination: JunkDestinationEnum
}

export enum ParentRelationEnum {
  reply = 'BESVART',
  replyAll = 'BESVART_ALLE',
  forward = 'VIDERESENDT',
}
